/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Button, Modal } from '@mairistem/composants';

interface Props {
  open: boolean;
  typeActe?: string;
  nomActe?: string;
  onClose: () => void;
  onConsulterActe: () => void;
  onNouvelActe: () => void;
  onRetourAccueil: () => void;
}

const AssistantModalFin = (props: Props) => {
  // #region Declarations
  const {
    open,
    typeActe,
    nomActe,
    onClose,
    onConsulterActe,
    onNouvelActe,
    onRetourAccueil,
  } = props;

  // #endregion

  // #region Component

  return (
    <Modal open={open} onClose={onClose} size="tiny" closeIcon>
      <Modal.Header content={`Fin de la saisie de l'acte de ${typeActe}`} />
      <Modal.Content>
        <p>
          {`La création de l'acte de ${typeActe} de ${nomActe} est maintenant terminée.`}
        </p>
        <p>Que souhaitez-vous faire ?</p>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '0.75em',
            marginTop: '1.5em',
          }}
        >
          <Button
            data-testid="assistant-fin-consulter-acte"
            onClick={onConsulterActe}
            content="Vous rendre sur la fiche de l'acte"
            style={{ width: '320px' }}
          />
          <Button
            data-testid="assistant-fin-nouvel-acte"
            onClick={onNouvelActe}
            content="Saisir un nouvel acte"
            style={{ width: '320px' }}
          />
          <Button
            data-testid="assistant-fin-retour-accueil"
            onClick={onRetourAccueil}
            content="Revenir à l'accueil"
            style={{ width: '320px' }}
          />
        </div>
      </Modal.Content>
    </Modal>
  );

  // #endregion
};

export default AssistantModalFin;
